import { useEffect } from 'react';
import Header from "components/SelectAssessment/Header";
import AssessmentModal from 'components/SelectAssessment/AssessmentModal';
import { useAppDispatch } from 'app/hooks';
import { getClassesAction } from 'app/reducer/assessmentSlice';
import Layout from 'common/Layout';
import WelcomeBar from 'components/SelectAssessment/WelcomeBar';
import Footer from 'components/SelectAssessment/Footer';

const SelectText = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getClassesAction());
    },[dispatch])

    return(
        <Layout>
            <Header />
            <WelcomeBar />
            <AssessmentModal />
            <Footer />
        </Layout>
    );
}

export default SelectText;